<template>
    <div :class="textInputWrapperClass">
		<div><label :for="textInputId">{{label}}</label></div>
            <!-- eslint-disable-next-line vue/use-v-on-exact -->
			<input ref="textInput" :id="textInputId" name="" type="text" value="" v-model="textInternal" @keydown.ctrl="onCtrlDown" @keyup="onKeyUp" @keydown.meta="onCommandDown" @keydown.alt="onAltDown" @keydown="onKey" @paste="onPaste" @input="onInput">
            <text-canvas ref="textCanvas" style="display:none" :config="config"></text-canvas>
	</div>
</template>

<script type="ts">
import { ErrorPayload, ErrorsModule } from '@/store/modules/error'
import { TextCanvasConfig } from './TextCanvas.vue'
import TextCanvas from './TextCanvas.vue'
import { TextWithSize } from '@/models/text'

export default {
    name: 'single-line-text-editor',
    props: {
        optional: Boolean,
        text: String,
        textInputWrapperClass: String,
        textInputId: String,
        label: String,
        config: TextCanvasConfig,
        createTextWithSize: Boolean
    },
    data: function() {
        return {
            textInternal: this.text,
            ctrlPressed: false,
            commandPressed: false,
            altPressed: false,
            wasHandled: false,
            validChars: ['\u0020','\u0021','\u0022',
                '\u0023','\u0024','\u0025','\u0026',
                '\u0027','\u0028','\u0029','\u002A',
                '\u002C','\u002D','\u002E','\u002F',
                '\u0030','\u0031','\u0032','\u0033',
                '\u0034','\u0035','\u0036','\u0037',
                '\u0038','\u0039','\u003A','\u003B',
                '\u003C','\u003D','\u003E','\u003F',
                '\u0040','\u0041','\u0042','\u0043',
                '\u0044','\u0045','\u0046','\u0047',
                '\u0048','\u0049','\u004A','\u004B',
                '\u004C','\u004D','\u004E','\u004F',
                '\u0050','\u0051','\u0052','\u0053',
                '\u0054','\u0055','\u0056','\u0057',
                '\u0058','\u0059','\u005A','\u005B',
                '\u005D','\u005E','\u005F','\u0060',
                '\u0061','\u0062','\u0063','\u0064',
                '\u0065','\u0066','\u0067','\u0068',
                '\u0069','\u006A','\u006B','\u006C',
                '\u006D','\u006E','\u006F','\u0070',
                '\u0071','\u0072','\u0073','\u0074',
                '\u0075','\u0076','\u0077','\u0078',
                '\u0079','\u007A','\u007B','\u007C',
                '\u007D','\u007E','\u00A1','\u00A2',
                '\u00A3','\u00A4','\u00A5','\u00A6',
                '\u00A7','\u00A8','\u00A9','\u00AA',
                '\u00AB','\u00AC','\u00AD','\u00AE',
                '\u00AF','\u00B0','\u00B1','\u00B2',
                '\u00B3','\u00B4','\u00B5','\u00B6',
                '\u00B7','\u00B8','\u00B9','\u00BA',
                '\u00BB','\u00BC','\u00BD','\u00BE',
                '\u00BF','\u00C0','\u00C1','\u00C2',
                '\u00C3','\u00C4','\u00C5','\u00C6',
                '\u00C7','\u00C8','\u00C9','\u00CA',
                '\u00CB','\u00CC','\u00CD','\u00CE',
                '\u00CF','\u00D0','\u00D1','\u00D2',
                '\u00D3','\u00D4','\u00D5','\u00D6',
                '\u00D7','\u00D8','\u00D9','\u00DA',
                '\u00DB','\u00DC','\u00DD','\u00DE',
                '\u00DF','\u00E0','\u00E1','\u00E2',
                '\u00E3','\u00E4','\u00E5','\u00E6',
                '\u00E7','\u00E8','\u00E9','\u00EA',
                '\u00EB','\u00EC','\u00ED','\u00EE',
                '\u00EF','\u00F0','\u00F1','\u00F2',
                '\u00F3','\u00F4','\u00F5','\u00F6',
                '\u00F7','\u00F8','\u00F9','\u00FA',
                '\u00FB','\u00FC','\u00FD','\u00FE',
                '\u00FF','\u0152','\u0153','\u0160',
                '\u0161','\u0178','\u017D','\u017E',
                '\u0192','\u02C6','\u02DC','\u2013',
                '\u2014','\u2018','\u2019','\u201A',
                '\u201C','\u201D','\u201E','\u2020',
                '\u2021','\u2022','\u2026','\u2030',
                '\u2039','\u203A','\u20AC','\u2122'
            ]
        }
    },
    methods: {
        validate: function() {
            let hasForbiddenChars = false
            let hasInvalidChars = false
            let forbiddenError = { key: 'forbiddenCharacters' }
            let invalidError = { key: 'invalidCharacters' }
            if(this.textInternal.match(/[<>{}§]/g)) {
                forbiddenError.message = 'Bitte überprüfen Sie Ihre Eingaben. Es dürfen keine unzulässigen Zeichen vorkommen ( <>{}§ ). Vielen Dank.'
                ErrorsModule.SetError(forbiddenError)
                hasForbiddenChars = true
            }
            let charArray = this.textInternal.split('')
            for (let i = 0; i < charArray.length; i++) {
                if (!this.validChars.includes(charArray[i])) {
                    invalidError.message = 'Bitte überprüfen Sie Ihre Eingaben. Es wurden unzulässigen Zeichen eingegeben. Vielen Dank.'
                    ErrorsModule.SetError(invalidError)
                    hasInvalidChars = true
                }
            }
            if (hasForbiddenChars || hasInvalidChars) {
                if (!hasForbiddenChars) {
                    ErrorsModule.SetError(forbiddenError)
                }
                if (!hasInvalidChars) {
                    ErrorsModule.SetError(invalidError)
                }
                return false
            }
            ErrorsModule.SetError(forbiddenError)
            ErrorsModule.SetError(invalidError)
            if(this.optional !== true) {
                if(!this.textInternal || this.textInternal.trim().length === 0) {
                    return false
                }
            }
            return true
        },
        onInput: function() {
            if(this.wasHandled) {
                this.wasHandled = false
            }else {
                this.handleInput(this.textInternal, null)
            }
        },
        onKey: function(event) {
            if(!(this.ctrlPressed || this.commandPressed || this.altPressed) && /^.{1}$/.test(event.key)) {
                this.wasHandled = true
                var text = ""
                var position = event.target.selectionStart
                var positionEnd = event.target.selectionEnd
                if(position == 0) {
                    text = event.key + this.textInternal.substring(positionEnd)
                }else if(position <= this.textInternal.length) {
                    text = this.textInternal.substring(0, position) + event.key
                    if(positionEnd <= this.textInternal.length) {
                        text = text + this.textInternal.substring(positionEnd)
                    }
                }else {
                    text = this.textInternal + event.key
                }
                this.handleInput(text, event)

            }
        },
        onPaste: function(event) {
            this.wasHandled = false
            let eventText = event.clipboardData.getData('text')
            let text = ""
            let position = event.target.selectionStart
            let positionEnd = event.target.selectionEnd
            if(position == 0) {
                text = eventText + this.textInternal.substring(positionEnd)
            }else if(position <= this.textInternal.length) {
                text = this.textInternal.substring(0, position) + eventText
                if(positionEnd <= this.textInternal.length) {
                    text = text + this.textInternal.substring(positionEnd)
                }
            }else {
                text = this.textInternal + eventText
            }
            this.handleInput(text, event)
        },
        handleInput: function(text, event) {
            var fitTextOnCanvasResult = this.$refs.textCanvas.fitTextOnCanvas(text)
            if(fitTextOnCanvasResult.cutInputCount > 0) {
                if(event) {
                    event.preventDefault()
                }
                text = text.substring(0, text.length - fitTextOnCanvasResult.cutInputCount)
                this.textInternal = text
            }
            this.$emit('changeInternal', text)
            if(this.createTextWithSize) {
                this.$emit('change', new TextWithSize(fitTextOnCanvasResult.text, fitTextOnCanvasResult.size))
            } else {
                this.$emit('change', fitTextOnCanvasResult.text)
            }
        },
        onCtrlDown: function() {
            this.ctrlPressed = true
        },
        onCommandDown: function() {
            this.commandPressed = true
        },
        onAltDown: function() {
            this.altPressed = true
        },
        onKeyUp: function(event) {
            if(event.key == "Meta") {
                this.commandPressed = false
            }else if(event.key == "Control") {
                this.ctrlPressed = false
            }else if(event.key == "Alt") {
                this.altPressed = false
            }
        }
    },
    mounted: function() {
        if(this.optional != null && this.optional === false) {
          this.$refs.textInput.focus();
        }
    },
    components: {
        TextCanvas
    }
}
</script>


<style lang="scss">
    #single-line-text-editor {
        input:focus{
            outline: none;
            border-color:#80bdff;
            box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.25);
        }
    }
</style>